import React from "react";
import { Divider } from "@material-ui/core";
import Container from "@material-ui/core/Container";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { Helmet } from "react-helmet";
import { useQuery } from "react-query";
import { useParams } from "react-router-dom";
import Error from "../../../../components/Error";
import Loading from "../../../../components/Loading";
import { endOfTitle } from "../../../../constants/constants";
import { ViewMoreDetailsWidget } from "../../../program/components/ViewMorePage/ViewMoreDetailsWidget";
import { ExtraDocumentsWidget } from "../../../program/components/ViewMorePage/ExtraDocumentsWidget";
import usePrivateClassQueries from "../../hooks/usePrivateClassQueries";
import { parseToPrivateClassViewMoreFrontEndModel } from "../../helpers/parseToPrivateClassViewMoreFrontEndModel";
import { TeacherInfoWidget } from "./TeacherInfoWidget";
import { PrivateClassSubInfoWidget } from "./PrivateClassSubInfoWidget";
import { ClassDescriptionWidget } from "./ClassDescriptionWidget";

const useStyles = makeStyles(() => ({
  main: {
    display: "flex",
    justifyContent: "center",
  },
  root: {
    width: 1144,
    border: "1px solid #e8eaf0",
    background: "#FFFFFF",
    boxShadow: "0px 0px 8px #C2C9D6",
    borderRadius: 15,
  },
  content: {
    padding: "16px 32px 32px",
  },
  divider: {
    backgroundColor: "#DBDBDB",
  },
  subContainer: {
    marginTop: 42,
  },
  extraDocumentsContainer: {
    marginTop: 56,
  },
}));

export const PrivateClassViewMorePage = () => {
  const classes = useStyles();

  const params: { id: string } = useParams();
  const { fetchViewMore } = usePrivateClassQueries();

  const { isLoading, data } = useQuery<any>(`${params.id}`, fetchViewMore);

  if (isLoading) {
    return <Loading />;
  }

  const privateClass = data
    ? parseToPrivateClassViewMoreFrontEndModel(data.data)
    : null;

  return (
    <Container maxWidth="lg" className={classes.main}>
      <Helmet>
        <title>View More{endOfTitle}</title>
      </Helmet>
      {!privateClass ? (
        <Error text={"The private class was not found"} />
      ) : (
        <div className={classes.root}>
          <TeacherInfoWidget
            teacherId={privateClass.teacherId}
            teacherName={privateClass.teacher.fullName}
            profilePicture={privateClass.teacher.profilePicture}
          />
          <Divider className={classes.divider} />
          <div className={classes.content}>
            <PrivateClassSubInfoWidget
              subjectName={privateClass.subjectName}
              teachingLanguage={privateClass.teachingLanguage}
              country={privateClass.teacher.country}
            />
            {!!privateClass.description && (
              <div className={classes.subContainer}>
                <ClassDescriptionWidget
                  description={privateClass.description}
                />
              </div>
            )}
            {!!privateClass.extraFiles?.length && (
              <div className={classes.extraDocumentsContainer}>
                <ExtraDocumentsWidget extraDocuments={privateClass.extraFiles} />
              </div>
            )}
            <div className={classes.subContainer}>
              <ViewMoreDetailsWidget
                programDetails={privateClass.details}
                title="Teacher Details"
              />
            </div>
            {!!privateClass.teacher.certificates?.length && (
              <div className={classes.extraDocumentsContainer}>
                <ExtraDocumentsWidget
                  extraDocuments={privateClass.teacher.certificates}
                  title="Certificates"
                />
              </div>
            )}
            {!!privateClass.teacher.cv && (
              <div className={classes.extraDocumentsContainer}>
                <ExtraDocumentsWidget
                  extraDocuments={[privateClass.teacher.cv]}
                  title="CV"
                />
              </div>
            )}
          </div>
        </div>
      )}
    </Container>
  );
};
